// extracted by mini-css-extract-plugin
export default {"maincontainer":"FormContainer_maincontainer__RW1Yw"};